import { useDeleteItemMutation } from 'api/ordering-service/ordering-service';
import { ItemResult } from 'api/ordering-service/ordering-service.types';
import ConfirmationDrawer from 'components/drawers/confirmation-drawer/confirmation-drawer.component';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

type ItemDeleteDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData: Partial<ItemResult>;
};

const ItemDeleteDrawer = ({
  open,
  close,
  drawerData,
}: ItemDeleteDrawerProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [triggerDeleteItem] = useDeleteItemMutation();

  const onConfirmationValid = async () => {
    try {
      await triggerDeleteItem({ itemId: drawerData?.itemId }).unwrap();
      enqueueSnackbar(
        t('ItemsDataGrid.actions.delete.alertMessage', {
          itemTitle: drawerData?.title,
        }),
        {
          severity: 'success',
        },
      );
    } catch (_e) {}
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      subtitle={t('drawer.itemDeleteDrawer.subtitle', {
        itemTitle: drawerData?.title,
      })}
      submitButtonLabel={t('drawer.itemDeleteDrawer.submitButtonLabel')}
      onValid={onConfirmationValid}
      cancel={close}
      color="error"
    />
  );
};

export default ItemDeleteDrawer;
